import { writable } from "svelte/store";
import { DEFAULT_THEME } from "../../styles/themes/themes";
export const theme = writable(DEFAULT_THEME);
export const INTERNAL_ACCESS_KEY = "token";
const INTERNAL_ACCESS_VALUES = ["ZerRgzEesBWBBjxvkYtaiFIP"];
export const isTokenValid = (token) => {
    return INTERNAL_ACCESS_VALUES.indexOf(token) !== -1;
};
export const headTitleStore = writable("");
export function setHeadTitle(title) {
    headTitleStore.set(title);
}
